import { MantineColor } from "@mantine/core";
import { i18n } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import type { AlertSeverity } from "../../apis/return-prevention-alert";
import { DotPill, Tone } from "../delivery/atoms";

export function severityLabel (severity?: AlertSeverity | string | null): string {
  if (!severity) return "";
  return i18n.t(`returns:alertSeverity.${severity}`, { defaultValue: severity });
}

export const SEVERITY_COLOR: Record<AlertSeverity, MantineColor> = {
  INFO    : "blue",
  WARNING : "orange",
  CRITICAL: "red",
};

/** Dot tone: critical red, warning amber, info blue (dot only; text stays dark). */
export const SEVERITY_TONE: Record<AlertSeverity, Tone> = {
  INFO    : "blue",
  WARNING : "amber",
  CRITICAL: "red",
};

interface Props {
  severity: AlertSeverity;
  /** Kept for call-site compatibility; the dot pill has one size. */
  size?: "xs" | "sm" | "md" | "lg";
}

export function AlertSeverityBadge({ severity }: Props) {
  const { t } = useTranslation("returns");
  return <DotPill tone={SEVERITY_TONE[severity] ?? "grey"}>{t(`alertSeverity.${severity}`, { defaultValue: "-" })}</DotPill>;
}
